import * as actionTypes from "./actionTypes";

// Trigger a disconnect request
export const setDisconnectWalletRequest = () => ({
  type: actionTypes.SET_DISCONNECT_WALLET_REQUEST,
});

// Mark disconnect as successful
export const setDisconnectWalletSuccess = () => ({
  type: actionTypes.SET_DISCONNECT_WALLET_SUCCESS,
});

// Mark disconnect as failed
export const setDisconnectWalletFailure = (error) => ({
  type: actionTypes.SET_DISCONNECT_WALLET_FAILURE,
  payload: error,
});
